import { createPortal } from 'react-dom';

type ImageLightboxProps = {
  src: string;
  alt: string;
  onClose: () => void;
};

/** Full-viewport image preview; portaled to body so parent overflow/transform cannot clip it. */
export default function ImageLightbox({ src, alt, onClose }: ImageLightboxProps) {
  return createPortal(
    <div
      className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/70 p-4"
      role="dialog"
      aria-modal="true"
      onClick={onClose}
    >
      <img
        src={src}
        alt={alt}
        className="max-w-full max-h-[85vh] object-contain rounded-lg shadow-2xl border-4 border-white"
        onClick={(e) => e.stopPropagation()}
      />
    </div>,
    document.body,
  );
}
